import { render } from "./DownloadableReport.vue?vue&type=template&id=1b09ff9a&scoped=true&ts=true"
import script from "./DownloadableReport.vue?vue&type=script&lang=ts"
export * from "./DownloadableReport.vue?vue&type=script&lang=ts"

import "./DownloadableReport.vue?vue&type=style&index=0&id=1b09ff9a&lang=scss&scoped=true"

import exportComponent from "/home/nathan/public_html/accident-plan/accident-plan-api-whitelabel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b09ff9a"]])

export default __exports__